import { render, staticRenderFns } from "./ItemTransportTable.vue?vue&type=template&id=4859b8da&"
import script from "./ItemTransportTable.vue?vue&type=script&lang=js&"
export * from "./ItemTransportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports